import { InformationCircleIcon } from "@hugeicons-pro/core-stroke-rounded";
import { ConfirmDialog } from "shared/components/modals/ConfirmDialog";

interface ApprovedAppWarningModalProps {
  isOpen: boolean;
  onClose: () => void;
  onConfirm: () => void;
  isSubmitting: boolean;
}

export const ApprovedAppWarningModal = ({
  isOpen,
  onClose,
  onConfirm,
  isSubmitting
}: ApprovedAppWarningModalProps) => (
  <ConfirmDialog
    opened={isOpen}
    onClose={onClose}
    onConfirm={onConfirm}
    title="Multiple approvals for the unit"
    description="There is an existing applicant in 'approved' or 'conditionally approved' status for the same unit"
    variant="primary"
    icon={{ icon: InformationCircleIcon, variant: "danger" }}
    confirmButton={{ label: "Continue anyway", loading: isSubmitting }}
    cancelButton={{ label: "Cancel" }}
    showCloseButton
    buttonsDirection="flex-col-reverse"
  />
);
